module.exports = __webpack_public_path__ + "static/img/6196_phase_function_Paper_PointsHejduk_Prediction.6aa1823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6196_phase_function_Paper_PointsHejduk_Prediction.png
// module id = iCdZ
// module chunks = 0